import { Component, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { NavbarComponent } from "./shared/components/navbar/navbar.component";
import { FooterComponent } from "./shared/components/footer/footer.component";
import { filter } from 'rxjs/operators';
import { InvestmentFlowService } from './core/services/Investment-flow/investment-flow.service';
import { StartInvestmentModalComponent } from "./features/home/components/start-investment-modal/start-investment-modal.component";
import { OtpModalComponent } from "./features/home/components/otp-modal/otp-modal.component";
import { ModalComponent } from "./shared/components/modal/modal.component";

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NavbarComponent,
    FooterComponent,
    StartInvestmentModalComponent,
    OtpModalComponent,
    ModalComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('Awalan');

  showFooterBg = false;
  showInvestment = true;
  showMainNavbar = true;
  showFooter=true;
  constructor(
    private router: Router,
    public flow: InvestmentFlowService
  ) {
   this.router.events
  .pipe(filter((e) => e instanceof NavigationEnd))
  .subscribe(() => {
    this.showFooterBg = this.router.url === '/';
    this.showInvestment = this.router.url !== '/profile';
      const url = this.router.url;

        this.showFooterBg = url === '/';
        this.showInvestment = url !== '/profile';

        const isUserDashboard = url.startsWith('/dashboard');
        const isAdminDashboard = url.startsWith('/admin');

        this.showMainNavbar = !isUserDashboard && !isAdminDashboard;
        this.showFooter = !isAdminDashboard;
  });
  }
}